import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {HOTB} from "../../HOTB";
import {GameConfig} from "../../GameConfig";
import {GameUtils} from "../../utils/GameUtils";
import {gsap} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class NormalBetPresentation implements FlowStatePresentation {
    constructor() {

    }

    public start(flowStateController: FlowStateController): void {
        GameConfig.isGameIdle = false;
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: (): void => {
                    flowStateController.finish();
                }
            }),
            isSatanSpin: boolean = GameUtils.isSatanSpin(),
            isCapMachineGame: boolean = GameUtils.isCapMachineGame(),
            delay: number = GameUtils.isFastSpin() ? GameConfig.reelAllOutStopDelayFastSpin : GameConfig.reelAllOutStopDelay;

        let satanSpinDelay: number = 0;

        if (isSatanSpin) {
            if (HOTB.autoPlayPlugin.isAutoplayRound || !(HOTB.reelArea.satanSymbolVisible)) {
                satanSpinDelay = GameConfig.SATAN_SPIN_START_DELAY_IN_AUTOPLAY;
            } else {
                satanSpinDelay = GameConfig.SATAN_SPIN_START_DELAY
            }

            tl.add(HOTB.satanSpinView.onSpinStart());
        }

        if (isCapMachineGame) {
            tl.add(HOTB.pickAndClickView.onSpinStart());
        }

        tl.add([
            HOTB.topReel.onSpinStart(),
            HOTB.leftReel.onSpinStart(),
            HOTB.rightReel.onSpinStart(),
            (): void => {
                HOTB.gameMultiplier.onSpinStart();
                HOTB.gameBackground.onSpinStart();
                HOTB.soundPlayer.onSpinStart();
                GameConfig.TOTAL_SCATTER_COUNT = 0;
                GameConfig.scatterPositions = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => -1);
                GameConfig.hasAnticipation = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => false);
                // #418
                GameConfig.scatterSoundsPlayed = [];
                HOTB.waysCounter.updateWaysCounter(true);
            }
        ], delay + satanSpinDelay);

        for (let i: number = 0; i < GameConfig.totalReels; i++) {
            tl.add(HOTB.reelArea.mainReelModels[i].start(), (delay * i) + satanSpinDelay);
        }
    }
}